<template>
  <div>
    <textarea
      ref="inputDom"
      :id="localId !== '' ? localId : null"
      :name="name"
      :rows="rows"
      :cols="cols"
      :disabled="disabled"
      :required="required"
      :readonly="readonly"
      v-model="valueCopy"
      @input="onChange"
    />
  </div>
</template>

<script>
export default {
  name: 'app-textarea',
  props: {
    name: {
      type: String,
      default: ''
    },
    value: {
      type: String
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    rows: {
      type: String,
      default: '2'
    },
    cols: {
      type: String,
      default: '50'
    },
    localId: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  beforeMount() {
    this.copyValue(this.value)
  },
  mounted() {
    if (this.$refs.inputDom.form) {
      this.$refs.inputDom.form.addEventListener('reset', this.onFormReset)
    }
  },
  beforeDestroy() {
    if (this.$refs.inputDom.form) {
      this.$refs.inputDom.form.removeEventListener('reset', this.onFormReset)
    }
  },
  data() {
    return {
      valueCopy: null
    }
  },
  methods: {
    onChange(event) {
      this.$emit('input', event.target.value, event)
    },
    copyValue(value) {
      this.valueCopy = value
    },
    onFormReset() {
      this.copyValue('')
    }
  },
  watch: {
    value(newValue) {
      // This watch works from the code side of the 2-way-binding:
      this.copyValue(newValue)
    }
  }
}
</script>
